// @ts-ignore
import Index from './src/Index.vue'
import {withInstall} from "../../utils/install";

Index.name = 'local-select';
export const LocalSelect = withInstall(Index);

export default LocalSelect;
